import { useEffect, useState } from "react"

export function useActiveScrollItem<T extends string>(
    featureRefs: React.MutableRefObject<Map<T, HTMLDivElement>>,
    features: { permaLink: T }[] | undefined,
) {
    const [activeItemId, setActiveItemId] = useState<T | null>(null)

    useEffect(() => {
        if (!features || features.length === 0) return

        const handleScroll = () => {
            let closestItem: { permaLink: T | ""; distance: number } = {
                permaLink: "" as T,
                distance: Infinity,
            }

            featureRefs.current.forEach((element, permaLink) => {
                if (!element) return

                const rect = element.getBoundingClientRect()
                const distance = Math.abs(rect.top - 20)

                // Skip if completely below viewport
                if (rect.bottom < 0) return

                if (distance < closestItem.distance) {
                    closestItem = { permaLink, distance }
                }
            })

            if (closestItem.permaLink && closestItem.permaLink !== activeItemId) {
                setActiveItemId(closestItem.permaLink)
            }
        }

        let ticking = false
        const onScroll = () => {
            if (!ticking) {
                requestAnimationFrame(() => {
                    handleScroll()
                    ticking = false
                })
                ticking = true
            }
        }

        window.addEventListener("scroll", onScroll)
        handleScroll()

        return () => {
            window.removeEventListener("scroll", onScroll)
        }
    }, [features, activeItemId])

    // initial item when loaded
    useEffect(() => {
        if (features && features.length > 0 && !activeItemId) {
            setActiveItemId(features[0].permaLink)
        }
    }, [features, activeItemId])

    return { activeItemId, setActiveItemId }
}
